module.exports = __webpack_public_path__ + "static/book-6bf57d85b4bd7feeb6c6debff0d377da.jpg";